import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TemplateFolder } from '@ps/survey-utils';

export const TemplateActions = createActionGroup({
  source: 'Template',
  events: {
    'Load Templates': props<{
      hasImpersonatedBuyer: boolean;
      companyId: number;
    }>(),
    'Create Template Folder': props<{
      name: string;
      parentFolderId?: number;
    }>(),
    Reset: emptyProps(),
  },
});

export const TemplateApiActions = createActionGroup({
  source: 'Template API',
  events: {
    'Load Templates Success': props<{
      templates: TemplateFolder[];
      cachedAt: number;
    }>(),
    'Load Templates Failure': props<{ error: string }>(),
    'Create Template Folder Success': props<{ folder: TemplateFolder }>(),
    'Create Template Folder Failure': props<{ error: string }>(),
  },
});
